import preferences from 'Preferences';
import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';
import {ScrollableTablePreferences} from 'ui-library/scrollable/ScrollableTableConstants';

import {ScrollableTableUIActionType} from './ScrollableTableUIReduxActions';

// Save as a constant so we don't incur re-renders unnecessarily.
const NO_HIDDEN_COLUMNS: Array<string> = [];

export class ScrollableTableUISelector {
  constructor(readonly state: BenchlingState) {
    this.state = state;
  }

  getHiddenColumnKeysForTable(
    tableKey: string,
    defaultHiddenColumnKeys?: Array<string> | null
  ): Array<string> {
    if (this.state.ui.scrollableTables.stateByTableKey[tableKey]) {
      return this.state.ui.scrollableTables.stateByTableKey[tableKey].hiddenColumnKeys;
    }
    const hiddenColumnsPreference = preferences.get(
      `${tableKey}${ScrollableTablePreferences.HIDDEN_COLUMN_NAMESPACE}`
    );
    if (hiddenColumnsPreference) {
      return defaultHiddenColumnKeys != null
        ? hiddenColumnsPreference.concat(defaultHiddenColumnKeys)
        : hiddenColumnsPreference;
    }
    return defaultHiddenColumnKeys ?? NO_HIDDEN_COLUMNS;
  }
}

export interface ScrollableTableUIState {
  stateByTableKey: {
    [tableKey: string]: {
      hiddenColumnKeys: Array<string>;
    };
  };
}

const INITIAL_STATE = {
  stateByTableKey: {},
};

export default function reduceScrollableTableUI(
  state: ScrollableTableUIState = INITIAL_STATE,
  action: BenchlingAction
): ScrollableTableUIState {
  switch (action.type) {
    case ScrollableTableUIActionType.HIDDEN_COLUMNS_UPDATED: {
      const {tableKey, hiddenColumnKeys} = action;
      return {
        ...state,
        stateByTableKey: {
          ...state.stateByTableKey,
          [tableKey]: {...state.stateByTableKey[tableKey], hiddenColumnKeys},
        },
      };
    }
    default: {
      return state;
    }
  }
}
